const _temp0 = require("./main.webp");
const _temp1 = require("./nexus_022.webp");
module.exports = {
  "main": _temp0,
  "nexus_022": _temp1
}